/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import Modal from "../Modal";
import { shallowEqual, useSelector } from "react-redux";

import { employeeDetailView, employeePreview } from "../../utils/employee";
import { ProfileImage } from "../Profile";
import ToolTip from "../ToolTip/ToolTip";

import mail from "../../assets/images/icon/mail-icon.svg";
import tel from "../../assets/images/icon/tel-icon.svg";
import nameCard from "../../assets/images/icon/name-card-icon.svg";
import building from "../../assets/images/icon/building-icon.svg";
import Icon from "../Icon";
import Button from "../Button";
import { transformMobile } from "../../utils/validator/mobile";
import { WORK_ADMIN_TYPES } from "../../constants/ROLE";

const PreviewEmployee = () => {
  const { previewEmployee, role } = useSelector(
    (store) => ({
      previewEmployee: store.Employee.previewEmployee,
      role: store.Profile.role,
    }),
    shallowEqual
  );

  const cancel = () => {
    // setOpen(false);
    employeePreview(null);
  };

  return (
    <Modal
      size="sm"
      type="fit"
      isOpen={!!previewEmployee}
      close={cancel}
      className="preview-employee-modal"
    >
      {previewEmployee &&
        <div className="preview-employee">
          {
            role && WORK_ADMIN_TYPES.includes(role.type) && <Button
              className="employee-detail-view-button"
              color="text"
              onClick={() => {
                employeeDetailView(previewEmployee.idx, { isTax: previewEmployee?.isTax });
              }}
            >
              상세보기
            </Button>
          }

          <div className="preview-employee-bg"></div>
          <div className="preview-employee-info">
            <div className="preview-employee-info-top">
              <p className="preview-profile-img">
                <ProfileImage data={previewEmployee} />
              </p>
              <div className="employee-icon-box">

                <ToolTip
                  tooltiptext={previewEmployee.email || '이메일이 없습니다.'}
                  position='bottom'
                  className="employee-icon employee-email"
                >
                  <Icon src={mail} />
                </ToolTip>
                <ToolTip
                  tooltiptext={previewEmployee.mobile ? transformMobile(previewEmployee.mobile) : '핸드폰이 없습니다.'}
                  className="employee-icon employee-phone"
                  position='bottom'
                >
                  <Icon src={tel} />
                </ToolTip>
              </div>
            </div>
            <div className="preview-employee-info-contents">
              <p className="employee-name">{previewEmployee.name}</p>
              <p className="employee-grade">
                <Icon src={nameCard} />{!previewEmployee.gradeName ? '직급이 없습니다.' : `${previewEmployee.gradeName}`}
              </p>
              <p className="employee-part">
                <Icon src={building} />{!previewEmployee.partName ?
                  '소속된 팀이 없습니다.' :
                  <>{previewEmployee.partName}</>
                }
              </p>

            </div>
          </div>
          <Button onClick={cancel} className="close-button">확인</Button>
        </div>
      }
    </Modal>
  );
};

export default PreviewEmployee;
